import { InputWithLabel } from "../../create-question-modal";
import { Autocomplete, Box, Chip, Typography, Checkbox, TextField } from "@mui/material";
import { fileTypes } from "../../enums";
import { useState } from "react";

// Flatten and annotate file types
const flatFileTypes = fileTypes.flatMap((group) =>
  group.extensions.map((ext) => ({ ...ext, group: group.type }))
);

// Add special "ALL" group to top
const getGroupedOptions = () => [
  { group: "__all__", extension: "__all__" },
  ...flatFileTypes,
];

export const FileTypeSelector = ({ selected = [], setSelected }) => {
  const allExtensions = flatFileTypes.map((item) => item?.extension);
  console.log(allExtensions);
  console.log(selected);
  const isAllSelected = allExtensions.every((ext) => selected?.includes(ext));

  const handleGroupClick = (group) => {
    if (group === "__all__") {
      setSelected(isAllSelected ? [] : allExtensions);
      return;
    }

    const groupItems = flatFileTypes
      .filter((item) => item.group === group)
      .map((item) => item.extension);
    const allSelected = groupItems.every((ext) => selected.includes(ext));

    if (allSelected) {
      setSelected(selected.filter((ext) => !groupItems?.includes(ext)));
    } else {
      setSelected([...new Set([...selected, ...groupItems])]);
    }
  };

  return (
    <InputWithLabel label="Accepted File Types">
      <Autocomplete
        multiple
        fullWidth
        disableCloseOnSelect
        options={getGroupedOptions()}
        groupBy={(option) => option.group}
        getOptionLabel={(option) =>
          option.extension === "__all__" ? "Select All File Types" : option.extension
        }
        value={flatFileTypes.filter((opt) => selected.includes(opt.extension))}
        onChange={(_, value) => {
          const onlyRealItems = value.filter((v) => v.extension !== "__all__");
          setSelected(onlyRealItems.map((v) => v.extension));
        }}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip key={option.extension} label={option.extension} {...getTagProps({ index })} />
          ))
        }
        renderInput={(params) => <TextField {...params} placeholder="Select types..." />}
        renderOption={(props, option, { selected }) => {
          const isAll = option.extension === "__all__";
          return (
            <li {...props}>
              <Checkbox
                size="small"
                checked={
                  isAll
                    ? isAllSelected
                    : selected
                }
                indeterminate={
                  isAll && selected.length > 0 && selected.length < allExtensions.length
                }
                sx={{ mr: 1 }}
              />
              {isAll ? "Select All File Types" : option.extension}
            </li>
          );
        }}
        renderGroup={(params) => {
          if (params.group === "__all__") {
            return (
              <li key="select-all">
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    px: 0.5,
                    py: 0.5,
                    cursor: "pointer",
                    bgcolor: "rgba(0,0,0,0.04)",
                  }}
                  onClick={() => handleGroupClick("__all__")}
                >
                  <Checkbox
                    size="small"
                    checked={isAllSelected}
                    tabIndex={-1}
                    disableRipple
                  />
                  <Typography variant="subtitle2">Select All File Types</Typography>
                </Box>
              </li>
            );
          }

          return (
            <li key={params.key}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  px: 0.5,
                  py: 0.5,
                  cursor: "pointer",
                  bgcolor: "rgba(0,0,0,0.04)",
                }}
                onClick={() => handleGroupClick(params.group)}
              >
                <Checkbox
                  size="small"
                  checked={flatFileTypes
                    .filter((item) => item.group === params.group)
                    .every((item) => selected.includes(item.extension))}
                  indeterminate={flatFileTypes
                      .filter((item) => item.group === params.group)
                      .some((item) => selected.includes(item.extension)) &&
                    !flatFileTypes
                      .filter((item) => item.group === params.group)
                      .every((item) => selected.includes(item.extension))
                  }
                  tabIndex={-1}
                  disableRipple
                />
                <Typography variant="subtitle2">{params.group}</Typography>
              </Box>
              {params.children}
            </li>
          );
        }}
      />
    </InputWithLabel>
  );
};
